"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIRDROP_API_URLS = void 0;
var AIRDROP_API_URLS;
(function (AIRDROP_API_URLS) {
    AIRDROP_API_URLS["GET_BY_ID"] = "/v2/airdrop/get-by-id";
})(AIRDROP_API_URLS = exports.AIRDROP_API_URLS || (exports.AIRDROP_API_URLS = {}));
